import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_made_with_love = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Made with ♥ by`;
  }
);
const de_made_with_love = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Entwicklet mit ♥ von`;
  }
);
const sp_made_with_love = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Desarrollado con ♥ por`;
  }
);
const made_with_love = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("made_with_love", locale);
  if (locale === "en") return en_made_with_love();
  if (locale === "de") return de_made_with_love();
  return sp_made_with_love();
};
const en_github_link_title = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Source code on Github`;
  }
);
const de_github_link_title = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Quellcode auf Github`;
  }
);
const sp_github_link_title = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Código fuente en GitHub`;
  }
);
const github_link_title = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("github_link_title", locale);
  if (locale === "en") return en_github_link_title();
  if (locale === "de") return de_github_link_title();
  return sp_github_link_title();
};
const en_terms_of_use = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Terms of Use`;
  }
);
const de_terms_of_use = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Nutzungsbedingungen`;
  }
);
const sp_terms_of_use = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Términos de uso`;
  }
);
const terms_of_use = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("terms_of_use", locale);
  if (locale === "en") return en_terms_of_use();
  if (locale === "de") return de_terms_of_use();
  return sp_terms_of_use();
};
const en_imprint = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Imprint`;
  }
);
const de_imprint = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Impressum`;
  }
);
const sp_imprint = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Aviso legal`;
  }
);
const imprint = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("imprint", locale);
  if (locale === "en") return en_imprint();
  if (locale === "de") return de_imprint();
  return sp_imprint();
};
export {
  github_link_title as g,
  imprint as i,
  made_with_love as m,
  terms_of_use as t
};
